import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';
import { EExamKey } from '@gray/domain/enums/exam-key.enum';

/**
 * The coach's own performance figures. Four calls rather than one, so the cards land while the
 * charts and the student list are still being counted.
 *
 * No period travels with these: the screen is about a stretch of months, chosen with `months`.
 */
@Injectable({providedIn: 'root'})
export class CoachMetricsService {

  private apiPrefix = '/coach/metrics';

  constructor(
    private api: ApiService,
  ) {
  }

  private query(examKey: EExamKey, months: number): string {
    return `?examKey=${examKey}&months=${months}`;
  }

  getSummary(examKey: EExamKey, months: number): Observable<any> {
    return this.api.get(this.apiPrefix, this.query(examKey, months));
  }

  getMonthly(examKey: EExamKey, months: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/monthly`, this.query(examKey, months));
  }

  getStudents(examKey: EExamKey, months: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/students`, this.query(examKey, months));
  }

  getEvaluations(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/evaluations`);
  }
}
